import ApiRequest from '../request'

export default class Ags3 {
  constructor() {
    this.apiRequest = new ApiRequest()
  }
  async update(id, data) {
    try {
      const res = await this.apiRequest.put(`ags3/${id}`, { ...data })
      return res
    } catch (error) {
      return error.response
    }
  }
  async get(id) {
    try {
      const res = await this.apiRequest.get(`ags3/${id}`)
      return res
    } catch (error) {
      return error.response
    }
  }
}
